import { render, staticRenderFns } from "./categoriesCompareItem.vue?vue&type=template&id=121fce3b"
import script from "./categoriesCompareItem.vue?vue&type=script&lang=js"
export * from "./categoriesCompareItem.vue?vue&type=script&lang=js"
import style0 from "./categoriesCompareItem.vue?vue&type=style&index=0&id=121fce3b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports